<div class="card-header p-0">
    <div *ngIf="new" class="new-badge">New</div>
    <div *ngIf="forMerchants" class="parking-status">
        <span
            [ngClass]="{
                'bg-light': parking.parkingStatus == parkingStatus.NEW,
                'bg-warning': parking.parkingStatus == parkingStatus.PENDING,
                'bg-success': parking.parkingStatus == parkingStatus.PUBLISHED
            }"
            class="badge rounded-pill text-dark"
            >{{ parking.parkingStatus }}</span
        >
    </div>
    <carousel (activeSlideChange)="activeSlideChange($event)" *ngIf="images.length > 0" [class]="'gallery-carousel'">
        <slide *ngFor="let image of images; let i = index">
            <img *ngIf="i <= highestIndex" [src]="image.smallUrl" class="w-100" (click)="gotoParking()" />
        </slide>
    </carousel>
    <div class="no-image-icon">
        <i class="fa fa-image"></i>
    </div>
    <img class="w-100" src="/assets/images/parking/no_image.png" />
</div>
<div class="card-body">
    <!-- <ng-container *ngIf="parking.dailySavings">
        <div class="sticker-wrapper">
            <aside class="sticker yellow">
                <div class="text">
                    <div class="label">SAVE</div>
                    <div class="percentage">{{ parking.dailySavingsPercentage }}%</div>
                </div>

                <span class="fold"></span>
            </aside>
        </div>
    </ng-container> -->

    <h5 class="card-title cursor" (click)="gotoParking()">
        {{ parking.title || 'Unnamed Parking' }}
    </h5>
    <!-- <h6 *ngIf="parking.parkingLocationName" class="card-subtitle mb-2 text-info">{{ parking.parkingLocationName }}</h6> -->
    <h6 *ngIf="parking.parkingLocation && !parking.parkingLocationName" class="card-subtitle mb-2 text-info cursor" (click)="gotoParking()">
        {{ parking.parkingLocation.city }} <span *ngIf="parking.parkingLocation.suburb"> • {{ parking.parkingLocation.suburb }}</span>
    </h6>
    <div *ngIf="parking.parkingType == ParkingType.FLEX">
        <span class="badge bg-info" (click)="moreInfoFlex()"><i class="fa fa-info-circle"></i> {{ parking.niceType }}</span>
    </div>
    <div *ngIf="parking.parkingType == ParkingType.PARKING_COLLECTOR">
        <span class="badge bg-info" (click)="moreInfoCollector()"><i class="fa fa-info-circle"></i> {{ parking.niceType }}</span>
    </div>

    <ng-container *ngIf="parking.plans && parking.plans.length > 0 && parking.plans[0].feeInCents > 0">
        <div *ngIf="parking.numberOfBays <= 0 && parking.plans[0].feeInCents" class="text-danger">No parking spots available</div>
        <div class="divider my-4"></div>
        <div *ngFor="let plan of parking.plans; let i = index" class="d-inline-block">
            <div *ngIf="plan" [ngClass]="{ 'border-right': i == 0 && parking.plans!.length > 1 }" class="d-inline-block">
                <ng-container *ngIf="plan.feeInCents">
                    <h3 class="d-inline-block">
                        <span class="text-danger me-1">R{{ plan.feeInCents | formatCents }}</span>
                    </h3>
                    <small>{{ plan.term | parkingPlanTerm }}</small>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="!parking.plans || parking.plans.length == 0 || parking.plans[0].feeInCents == 0">
        <div class="divider my-4"></div>
        <div *ngIf="!parking.plans || parking.plans.length == 0 || parking.plans[0].feeInCents == 0" class="d-inline-block">
            <div class="d-inline-block">
                <ng-container>
                    <h6 class="d-inline-block"><span class="text-danger me-1">Price to be announced</span></h6>
                </ng-container>
            </div>
        </div>
    </ng-container>

    <div *ngIf="parking.admytLpr" class="d-inline-block float-end">
        <a data-bs-target="#admytModal" data-bs-toggle="modal">
            <img src="assets/images/parking/admyt-lpr.png" style="height: 50px" />
        </a>
    </div>

    <div *ngIf="parking.admytQr" class="d-inline-block float-end" style="text-align: right">
        <a data-bs-target="#admytModal" data-bs-toggle="modal">
            <img src="assets/images/parking/admyt-qr.png" style="height: 50px" />
        </a>
    </div>
</div>
